import { getCurrentUserDetails } from "@/graphql/queries.js";
import { graphqlRequest } from "@/services/api/client.js";
import { getApiMessage } from "@/utils/apiResponse.js";

export async function fetchCurrentUser(email) {
  try {
    const parsed = await graphqlRequest(getCurrentUserDetails, {
      input: { user_email_id: email },
    });
    return parsed;
  } catch (error) {
    return {
      status: "ERROR",
      message: getApiMessage(error, "Failed to get user details"),
    };
  }
}
